import { render, staticRenderFns } from "./PedigreeTable.vue?vue&type=template&id=62c8de94&"
import script from "./PedigreeTable.vue?vue&type=script&lang=js&"
export * from "./PedigreeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports